import React from "react";
import { FC, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { KTCard } from "src/resources/helpers";

type DownloadExportModalProp = {
  isModalOpen?: boolean;
  isModalClose?: () => void;
  fileUrl: string;
};

export const DownloadExportModal: FC<DownloadExportModalProp> = ({
  isModalOpen,
  isModalClose,
  fileUrl,
}) => {
  const { t } = useTranslation();
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [isDownloading, setIsDownloading] = useState<boolean>(false);
  const [downloadedFileName, setDownloadedFileName] = useState<string | null>(
    null
  );

  const handleDownload = () => {
    try {
      setIsDownloading(true);
      setErrorMessage(null);
      setDownloadedFileName(null);

      // Buat elemen anchor untuk memicu download
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = fileUrl;

      // Ambil nama file dari URL atau gunakan default
      const filename = decodeURIComponent(
        fileUrl.split("/").pop()?.split("?")[0] || "export-order.csv"
      );
      a.download = filename;

      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      setIsDownloading(false);
      setDownloadedFileName(filename);
    } catch (error) {
      setIsDownloading(false);
      setErrorMessage(error instanceof Error ? error.message : String(error));
    }
  };

  return (
    <>
      <Modal
        animation
        centered
        show={isModalOpen}
        scrollable={false}
        onHide={() => isModalClose && isModalClose()}
        // onBackdropClick={() => isModalClose && isModalClose()}
      >
        <Modal.Header closeButton className="bg-light my-0 py-3">
          <Modal.Title data-testid="download-modal-title" className="fs-3">
            {t("ExportOrder.Download.Title")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-light my-0 py-0">
          <KTCard className="flex h-100 py-10">
            {errorMessage ? (
              <div className="text-center">
                <p className="p-0 m-0 fs-5 text-danger">
                  {t("ExportOrder.Download.DownloadFailed")}
                </p>
                <p className="p-0 m-0 fs-5 mt-2 fw-bolder text-danger">
                  {errorMessage}
                </p>
              </div>
            ) : downloadedFileName ? (
              <div className="text-center">
                <p className="p-0 m-0 fs-5">
                  {t("ExportOrder.Download.DownloadComplete")}
                </p>
                <p className="p-0 m-0 fs-5 mt-2 fw-bolder">
                  {downloadedFileName}
                </p>
              </div>
            ) : !isDownloading ? (
              <p className="p-0 m-0 fs-5 text-center">
                {t("ExportOrder.Download.FileReady")
                  .split("\n")
                  .map((text, i) => (
                    <React.Fragment key={i}>
                      {text}
                      {i !==
                        t("ExportOrder.Download.FileReady").split("\n").length -
                          1 && <br />}
                    </React.Fragment>
                  ))}
              </p>
            ) : (
              <span className="indicator-progress" style={{ display: "block" }}>
                <span className="spinner-border spinner-border-md align-middle m-5"></span>
              </span>
            )}
          </KTCard>
        </Modal.Body>
        <Modal.Footer className="bg-light my-0 py-3">
          <Button
            variant="primary"
            onClick={handleDownload}
            disabled={isDownloading}
            className="btn btn-sm px-3"
          >
            {isDownloading
              ? t("ExportOrder.Download.downloading")
              : downloadedFileName || errorMessage
              ? t("ExportOrder.Download.downloadAgain")
              : t("ExportOrder.Download.downloadFile")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
